import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CdsLanguageModule } from '@cds/ng-core/lang';
import { CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';

import { AlertPopupComponent } from './alert-popup.component';

@NgModule({
  imports: [CommonModule, CdsPopupModule, CdsLanguageModule, CdsButtonModule, AlertPopupComponent],
  exports: [AlertPopupComponent],
})
export class AlertPopupModule {}
